import { useCallback } from 'react'
import { useSearchParams } from 'react-router-dom'
import { statisticsPeriodOptions } from './statistics'
import type { JdOrderStatisticsPeriod, JdOrderStatisticsWindow } from './jdOrderStatisticsWindow'
export { jdOrderStatisticsWindow } from './jdOrderStatisticsWindow'
export type { JdOrderStatisticsPeriod, JdOrderStatisticsWindow } from './jdOrderStatisticsWindow'

export const jdOrderStatisticsPeriodOptions: Array<{ key: JdOrderStatisticsPeriod, label: string }> = [
  ...statisticsPeriodOptions,
  { key: 'all', label: '全部' },
]
const supportedPeriods = new Set<JdOrderStatisticsPeriod>(jdOrderStatisticsPeriodOptions.map((item) => item.key))

export function useJdOrderStatisticsPeriod(defaultPeriod: JdOrderStatisticsPeriod = 'day') {
  const [searchParams, setSearchParams] = useSearchParams()
  const requested = searchParams.get('period') as JdOrderStatisticsPeriod | null
  const period = requested && supportedPeriods.has(requested) ? requested : defaultPeriod
  const setPeriod = useCallback((value: JdOrderStatisticsPeriod) => {
    setSearchParams((current) => {
      const next = new URLSearchParams(current)
      next.set('period', value)
      return next
    }, { replace: true })
  }, [setSearchParams])
  return [period, setPeriod] as const
}

export function JdOrderStatisticsBar({
  period,
  onChange,
  window,
  title = '统计时间范围',
  ariaLabel = '京东订单统计范围',
}: {
  period: JdOrderStatisticsPeriod
  onChange: (value: JdOrderStatisticsPeriod) => void
  window: JdOrderStatisticsWindow | null
  title?: string
  ariaLabel?: string
}) {
  const detail = window
    ? `${window.label} · ${window.startDate} ~ ${window.endDate}`
    : '订单数据加载中'
  const partial = window && window.startDate < window.dataStartDate
  return <div className="pdd-statistics-bar jd-statistics-bar">
    <div>
      <strong>{title}</strong>
      <small>{detail}{partial ? ` · 数据自 ${window.dataStartDate} 起，窗口早于数据起点的天数无数据` : ''}</small>
    </div>
    <div className="metric-switch" role="group" aria-label={ariaLabel}>
      {jdOrderStatisticsPeriodOptions.map((item) => <button
        type="button"
        key={item.key}
        className={item.key === period ? 'is-active' : ''}
        aria-pressed={item.key === period}
        onClick={() => onChange(item.key)}
      >{item.label}</button>)}
    </div>
  </div>
}
